import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadAppSettings } from './app/core/config/settings.loader';
import {
  init as SentryInit,
  browserTracingIntegration as SentryBrowserTracingIntegration,
  replayIntegration as SentryReplayIntegration,
} from '@sentry/angular';
import { version } from '../package.json';

startApplication().catch((error: unknown) => {
  console.error(error);
  showStartupError();
});

async function startApplication(): Promise<void> {
  const settings = await loadAppSettings();

  if (settings.sentry.dsn) {
    SentryInit({
      dsn: settings.sentry.dsn,
      integrations: [
        SentryBrowserTracingIntegration(),
        SentryReplayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: settings.sentry.tracesSampleRate,
      release: version,
      dist: version,
      sampleRate: 1.0,
      tracePropagationTargets: ['localhost', settings.apiBaseUrl, settings.auth.baseUrl],
      environment: settings.sentry.environment,
      replaysSessionSampleRate: settings.sentry.replaysSessionSampleRate,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  await bootstrapApplication(AppComponent, createAppConfig(settings));
}

/**
 * Reveals the static fallback in index.html. Without it a failed config load
 * skips bootstrap and leaves the user on a blank page with no way forward.
 */
function showStartupError(): void {
  document.getElementById('startup-error')?.removeAttribute('hidden');
}

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/ngsw-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.log('ServiceWorker registration failed: ', error);
      });
  });
}
